<template>
  <div class="menu-bar" :class="{ 'x-collapse': fold }">
    <div class="logo">
      <div class="item-icon">
        <!-- <img src="/images/logo.png" style="margin-top: 10px; height: auto; vertical-align: top;" alt="logo" /> -->
      </div>
      <div class="menu-title">兆配云CRM</div>
    </div>
    <template v-if="$store.state.privilegeLoaded">
      <menu-item v-for="menu in menuList" :menu-item="menu" :key="menu.code" :deep="1" :current-code="currentCode" @switch="handleSwitch"></menu-item>
    </template>
    <div class="toggle" @click="handleCollapse">
      <div class="inner">
        <i v-if="fold" class="crm-icon-double-arrow-right"></i>
        <i v-else class="crm-icon-double-arrow-left"></i>
      </div>
    </div>
    <div class="bottom-actions">
      <slot name="bottom" />
    </div>
  </div>
</template>
<script>
import MenuItem from './MenuItem'
export default {
  name: 'Menus',
  components: {
    MenuItem
  },
  props: {
    menuList: {
      type: Array,
      default () {
        return [
          {
            code: 'default',
            name: '工作台',
            clickHandler (ev) {
              ev.preventDefault()
            },
            icon: 'crm-icon-dashboard'
          }
        ]
      }
    },
    currentCode: {
      type: String,
      default () {
        return ''
      }
    },
    fold: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  methods: {
    handleSwitch (newCode) {
      this.$emit('switch', newCode)
    },
    handleCollapse () {
      this.$emit('fold')
    }
  }
}
</script>
